import angular from 'angular';
import { StepsConfig } from './steps.config';
import { StepsService } from './steps.service';
import { DiyMoveStepModule } from './diy-move';
import { DmvModule } from './dmv/dmv.module';
import { HomeServicesStepModule } from './home-services';
import { InsuranceStepModule } from './insurance';
import { InsuranceQuotesStep } from './insurance-quotes';
import { InsuranceRetentionStepModule } from './insurance-retention';
import { RentersInsuranceStepModule } from './renters-insurance';
import { AutoInsuranceStepModule } from './auto-insurance';
import { MovingCenterStepModule } from './moving-center';
import { ForwardMailStepModule } from './forward-mail';
import { HudsonInsuranceStepModule } from './hudson-insurance';
import { CustomInformationStepModule } from './custom-information';
import { RecommendedProvidersStepModule } from './recommended-providers';
import { ResidentPortalStepModule } from './resident-portal';
import { ShareMoveStepModule } from './share-move';
import { UpdateAccountsStepModule } from './update-accounts';
import { UtilitiesStepModule } from './utilities';
import { OffersStepModule } from './offers';
import { PromotionsStepModule } from './promotions';
import { RedCrossModule } from './red-cross';
import { MoveIQModule } from './moveiq';
import { HomeServicesAppModule } from './home-services-app';
import { HomeSecurityModule } from './home-security';
import { SmartHomeOwnModule } from './smart-home-own';
import { CaliforniaCareModule } from './california-care';
import { BackupGeneratorModule } from './backup-generator';
import { DukeWarrantyModule } from './duke-warranty';
import { MoveYourStuffModule } from './move-your-stuff';
import { FullServiceMoveModule } from './full-service-move';
import { PackingSuppliesModule } from './packing-supplies';

export const StepsModule = angular
  .module('app.steps', [
    DmvModule.name,
    DiyMoveStepModule.name,
    ForwardMailStepModule.name,
    HomeServicesStepModule.name,
    HudsonInsuranceStepModule.name,
    InsuranceStepModule.name,
    InsuranceQuotesStep.name,
    InsuranceRetentionStepModule.name,
    CustomInformationStepModule.name,
    RecommendedProvidersStepModule.name,
    ResidentPortalStepModule.name,
    ShareMoveStepModule.name,
    UpdateAccountsStepModule.name,
    UtilitiesStepModule.name,
    OffersStepModule.name,
    PromotionsStepModule.name,
    RentersInsuranceStepModule.name,
    AutoInsuranceStepModule.name,
    MovingCenterStepModule.name,
    RedCrossModule.name,
    MoveIQModule.name,
    HomeServicesAppModule.name,
    HomeSecurityModule.name,
    SmartHomeOwnModule.name,
    CaliforniaCareModule.name,
    BackupGeneratorModule.name,
    DukeWarrantyModule.name,
    MoveYourStuffModule.name,
    FullServiceMoveModule.name,
    PackingSuppliesModule.name,
  ])
  .config(StepsConfig)
  .service('Steps', StepsService);
